var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SearchOutline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 21.0943L15 15.0943M17 10.0943C17 11.0136 16.8189 11.9239 16.4672 12.7731C16.1154 13.6224 15.5998 14.3941 14.9497 15.0441C14.2997 15.6941 13.5281 16.2097 12.6788 16.5615C11.8295 16.9133 10.9193 17.0943 10 17.0943C9.08075 17.0943 8.1705 16.9133 7.32122 16.5615C6.47194 16.2097 5.70026 15.6941 5.05025 15.0441C4.40024 14.3941 3.88463 13.6224 3.53284 12.7731C3.18106 11.9239 3 11.0136 3 10.0943C3 8.23783 3.7375 6.45735 5.05025 5.1446C6.36301 3.83184 8.14348 3.09435 10 3.09435C11.8565 3.09435 13.637 3.83184 14.9497 5.1446C16.2625 6.45735 17 8.23783 17 10.0943Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutline);
export default __webpack_public_path__ + "static/media/SearchOutline.f9faf19cf7109e7df98a194672041a98.svg";
export { ForwardRef as ReactComponent };